module.exports = __webpack_public_path__ + "static/media/numericco_curso0016.da240a6e.jpg";